<template>
    <div id="all">
        <div id="searchbar">
            <SearchBar v-on:update-url="update"></SearchBar>
        </div>
        <div id="playerdisplay">
            <PlayerDisplay :url="url"></PlayerDisplay>
        </div>
    </div>
</template>

<script>

import SearchBar from './PlayerSearch/SearchBar'
import PlayerDisplay from './PlayerSearch/PlayerDisplay'

export default {
    name : "PlayerSearch",
    components: {
        SearchBar,
        PlayerDisplay
    },
    data() {
        return {
            url: "",
        }
    },
    methods: {
        update: function (url) {
            this.url = url
        }
    }
}
</script>

<style scoped>

#all {
    display: block;
    background-color: rgb(25, 27, 28);
    height: 100vh;
}

#searchbar {
    display: flex;
    align-items: center;
    justify-content: center;
    /* background-color: darkkhaki; */
    height: 15vh;
    min-block-size: 98px;
}

#playerdisplay {
    display: flex;
    align-items: center;
    justify-content: center;
    /* background-color: rgb(107, 189, 127); */
    height: 85vh;
}

</style>